import { TradersPage } from 'features/traders';

export const TechOperatorTradersPage: React.FC = () => <TradersPage />;
